import domPointLabel from './domPointLabel';
import domPointImage from './domPointImage';
import tooltip from './tooltip';

export {
  domPointLabel,
  domPointImage,
  tooltip,
};
